import React, { useState } from 'react';
import { LeadSource } from './types';
import { FilterBar } from '../../components/crm/all-leads/filterbar';
import { LeadCard } from '../../components/crm/all-leads/lead-card';
import { mockLeads } from './data';


// Components
const Header: React.FC = () => (
    <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
            <div className="text-white text-2xl">🔥</div>
            <h1 className="text-3xl md:text-2xl font-bold text-gray-900">All Leads</h1>
        </div>
        <p className="text-gray-600">Manage your pipeline with complete lead information and action history</p>
    </div>
);

const AllLeads: React.FC = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedSource, setSelectedSource] = useState<LeadSource>('All');
    const [expandedLeadId, setExpandedLeadId] = useState<string | null>(null);

    const filteredLeads = mockLeads.filter(lead => {
        const matchesSearch =
            lead.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
            lead.company.toLowerCase().includes(searchQuery.toLowerCase()) ||
            lead.title.toLowerCase().includes(searchQuery.toLowerCase());

        const matchesSource = selectedSource === 'All' || lead.source === selectedSource;

        return matchesSearch && matchesSource;
    });

    const sourceCounts: Record<LeadSource, number> = {
        'All': mockLeads.length,
        'LinkedIn': mockLeads.filter(l => l.source === 'LinkedIn').length,
        'Website': mockLeads.filter(l => l.source === 'Website').length,
        'Google Ads': mockLeads.filter(l => l.source === 'Google Ads').length,
        'Referral': mockLeads.filter(l => l.source === 'Referral').length,
        'Cold Outreach': mockLeads.filter(l => l.source === 'Cold Outreach').length
    };

    return (
        <div className="min-h-screen bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
                <Header />
                <FilterBar
                    searchQuery={searchQuery}
                    setSearchQuery={setSearchQuery}
                    selectedSource={selectedSource}
                    setSelectedSource={setSelectedSource}
                    sourceCounts={sourceCounts}
                />

                <div className="mb-4">
                    <p className="text-gray-600">
                        Showing <span className="font-semibold">{filteredLeads.length}</span> of{' '}
                        <span className="font-semibold">{mockLeads.length}</span> leads
                    </p>
                </div>

                <div className="space-y-4">
                    {filteredLeads.map((lead) => (
                        <LeadCard
                            key={lead.id}
                            lead={lead}
                            expanded={expandedLeadId === lead.id}
                            onToggle={() => setExpandedLeadId(expandedLeadId === lead.id ? null : lead.id)}
                        />
                    ))}
                </div>

                {filteredLeads.length === 0 && (
                    <div className="text-center py-12 bg-white rounded-lg shadow-sm border border-gray-200">
                        <p className="text-gray-500 text-lg">No leads found matching your criteria.</p>
                        <p className="text-gray-400 mt-2">Try adjusting your filters or search query.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default AllLeads;